import React from 'react';

/**
 * Sello de agua con la trama del papel membretado de Mercalia:
 * las constelaciones de lineas y puntos, y el globo con la M.
 *
 * Se usa en todas las secciones de fondo azul para que el sitio y los documentos
 * se lean como la misma marca.
 *
 * OJO: todas las coordenadas son NUMEROS FIJOS, nunca calculadas con trigonometria.
 * Un SVG con posiciones calculadas da distinto en el servidor y en el navegador
 * (difieren en el ultimo decimal) y eso dispara el error de hidratacion de React.
 */

type Intensidad = 'alta' | 'media' | 'baja';

const NIVELES: Record<Intensidad, { lineas: number; nodos: number; globo: number }> = {
  alta:  { lineas: 0.26, nodos: 0.48, globo: 0.12 }, // portada
  media: { lineas: 0.18, nodos: 0.34, globo: 0.09 }, // encabezados de las demas paginas
  baja:  { lineas: 0.10, nodos: 0.20, globo: 0.05 }, // pie y secciones largas
};

export default function TramaMembrete({
  intensidad = 'media',
  conGlobo = true,
}: {
  intensidad?: Intensidad;
  conGlobo?: boolean;
}) {
  const o = NIVELES[intensidad];

  return (
    <svg
      className="absolute inset-0 w-full h-full pointer-events-none select-none"
      viewBox="0 0 1200 560"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <g stroke="#7fd9e3" strokeWidth="1" fill="none" opacity={o.lineas}>
        <path d="M120 0 L232 64 L318 22 L430 96 L392 176 L268 148 L232 64" />
        <path d="M318 22 L452 -10 M430 96 L556 52 M268 148 L150 196 M392 176 L470 258" />
        <path d="M1040 560 L1128 470 L1066 392 L1160 330 M1128 470 L1200 500 M1066 392 L960 420" />
      </g>

      <g fill="#9fe4ec" opacity={o.nodos}>
        <circle cx="120" cy="0" r="5" /><circle cx="232" cy="64" r="7" /><circle cx="318" cy="22" r="5" />
        <circle cx="430" cy="96" r="8" /><circle cx="392" cy="176" r="5" /><circle cx="268" cy="148" r="6" />
        <circle cx="452" cy="-10" r="4" /><circle cx="556" cy="52" r="4" /><circle cx="150" cy="196" r="4" />
        <circle cx="470" cy="258" r="5" />
        <circle cx="1128" cy="470" r="7" /><circle cx="1066" cy="392" r="5" /><circle cx="1160" cy="330" r="6" />
        <circle cx="1040" cy="560" r="5" /><circle cx="960" cy="420" r="4" /><circle cx="1200" cy="500" r="4" />
      </g>

      {conGlobo && (
        <g transform="translate(905 280)" opacity={o.globo}>
          <circle r="150" fill="none" stroke="#bfefff" strokeWidth="1.2" />
          <ellipse rx="150" ry="58" fill="none" stroke="#bfefff" strokeWidth="1" />
          <ellipse rx="150" ry="110" fill="none" stroke="#bfefff" strokeWidth="1" />
          <ellipse rx="58" ry="150" fill="none" stroke="#bfefff" strokeWidth="1" />
          <ellipse rx="110" ry="150" fill="none" stroke="#bfefff" strokeWidth="1" />
          <g fill="#dff6ff">
            <circle cx="0" cy="-150" r="6" /><circle cx="0" cy="150" r="6" />
            <circle cx="-150" cy="0" r="6" /><circle cx="150" cy="0" r="6" />
            <circle cx="-106" cy="-106" r="5" /><circle cx="106" cy="-106" r="5" />
            <circle cx="-106" cy="106" r="5" /><circle cx="106" cy="106" r="5" />
            <circle cx="-58" cy="-58" r="4" /><circle cx="58" cy="58" r="4" />
          </g>
          <path
            d="M-78 66 L-78 -66 L-16 6 L46 -66 L46 66 L16 66 L16 -14 L-16 26 L-48 -14 L-48 66 Z"
            fill="#eaf9ff"
            opacity="0.95"
          />
        </g>
      )}
    </svg>
  );
}
